import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getPage, setGateway, distribute } from '@/api/admin/userStation';
import { getProjectAndDeviceList } from '@/api/deviceOverview/alarm';
import { projectPage, projectList } from '@/api/deviceOverview/file';
export default {
  name: 'stationModal',
  props: {
    dialogStationVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    }
  },
  data: function data() {
    return {
      ruleForm: {
        roleName: '',
        roleDesc: '',
        roleCode: ''
      },
      rules: {
        roleName: [{
          required: true,
          message: this.$t('userManage.addRoleName'),
          trigger: 'blur'
        }],
        roleDesc: [{
          required: true,
          message: this.$t('userManage.addRoleDes'),
          trigger: 'blur'
        }]
      },
      param: {
        current: 1,
        size: 10,
        total: 0,
        stationName: '',
        // 不用
        userId: '',
        // 获取用户设备和修改时使用
        userStation: [] // int数组,

      },
      loading: false,
      tableData: [],
      activeData: [],
      multipleSelection: [],
      column: [// {prop:'index',label:'序号'},
      {
        prop: 'projectName',
        label: this.$t('manipulation.devName')
      }, {
        prop: 'address',
        label: this.$t('manipulation.installAddress')
      }, {
        prop: 'deviceCount',
        label: this.$t('manipulation.insNum')
      }, {
        prop: 'organization',
        label: this.$t('realdetile.contUnit')
      }, {
        prop: 'installDate',
        label: this.$t('fileManage.timeSetting')
      }, {
        prop: 'devCode',
        label: this.$t('stationModal.devCode')
      }, {
        prop: 'deviceModel',
        label: this.$t('stationModal.devModel')
      }, {
        prop: 'towerNumber',
        label: this.$t('realtimeinfo.roomNum')
      }, {
        prop: 'stairsNumber',
        label: this.$t('realtimeinfo.eleNum')
      } // {prop:'status',label:'公司名称'},
      ],
      projectName: '',
      wayinfo: ''
    };
  },
  created: function created() {// this.param.userId = sessionStorage.getItem('stationUserId');
    // this.init();
  },
  mounted: function mounted() {},
  methods: {
    select: function select(selection, row) {
      var _this = this;

      if (selection.some(function (el) {
        return row.id === el.id;
      })) {
        if (row.deviceList) {
          row.deviceList.map(function (j) {
            _this.toggleSelection(j, true);
          });
        }
      } else {
        if (row.deviceList) {
          row.deviceList.map(function (j) {
            _this.toggleSelection(j, false);
          });
        }
      }
    },
    selectAll: function selectAll(selection) {
      var _this2 = this;

      // tabledata第一层只要有在selection里面就是全选
      var isSelect = selection.some(function (el) {
        var tableDataIds = _this2.tableData.map(function (j) {
          return j.id;
        });

        return tableDataIds.includes(el.id);
      }); // tableDate第一层只要有不在selection里面就是全不选

      var isCancel = !this.tableData.every(function (el) {
        var selectIds = selection.map(function (j) {
          return j.id;
        });
        return selectIds.includes(el.id);
      });

      if (isSelect) {
        selection.map(function (el) {
          if (el.deviceList) {
            el.deviceList.map(function (j) {
              _this2.toggleSelection(j, true);
            });
          }
        });
      }

      if (isCancel) {
        this.tableData.map(function (el) {
          if (el.deviceList) {
            el.deviceList.map(function (j) {
              _this2.toggleSelection(j, false);
            });
          }
        });
      }
    },
    // selectionChange (selection) {
    //     console.log(this.selectArr,'selectArr')
    // },
    toggleSelection: function toggleSelection(row, select) {
      var _this3 = this;

      if (row) {
        this.$nextTick(function () {
          _this3.$refs.multipleTable && _this3.$refs.multipleTable.toggleRowSelection(row, select);
        });
      }
    },
    init: function init() {
      this.getUserStation();
    },
    serchinfo: function serchinfo() {
      this.getUserStation(this.wayinfo);
    },
    result: function result() {
      this.projectName = '';
      this.param.current = 1;
      this.getUserStation(this.wayinfo);
    },
    selectionChange: function selectionChange(val) {
      this.selectArr = val;
      var arr = [];
      val.map(function (item, index) {
        if (item.projectId) {
          arr.push({
            projectId: item.projectId,
            deviceIds: [item.id]
          });
        } else {
          arr.push({
            projectId: item.id,
            deviceIds: []
          });
        }
      });
      var hash = Object.create(null);
      var test = arr.filter(function (o) {
        if (!hash[o.projectId]) {
          hash[o.projectId] = o.deviceIds;
          return true;
        }

        Array.prototype.push.apply(hash[o.projectId], o.deviceIds);
      });
      test.map(function (item) {
        if (item.deviceIds) {
          item.deviceIds = item.deviceIds.toString();
        }
      });
      this.multipleSelection = test;
    },
    getUserStation: function getUserStation(val, flag) {
      var _this4 = this;

      if (flag) {
        this.param.current = 1;
      }

      this.wayinfo = JSON.parse(JSON.stringify(val));

      if (val.deviceListStr) {
        this.multipleSelection = JSON.parse(val.deviceListStr);
      }

      val.id && (this.param.userId = val.id);

      var obj = _objectSpread({
        projectName: this.projectName
      }, this.param);

      getProjectAndDeviceList(obj).then(function (res) {
        res = res.data.data;
        res.map(function (item, index) {
          item.index = index + 1;
          item.deviceCount = item.deviceList.length;

          if (item.deviceList.length > 0) {
            item.deviceList.map(function (v) {
              v.deviceCount = "——";
              v.projectId = item.id;
            });
          }
        });
        _this4.tableData = res;

        _this4.$nextTick(function () {
          _this4.tableData.map(function (item, index) {
            val.projectIds && val.projectIds.split(',').map(function (v) {
              if (item.id === v) {
                _this4.$refs.multipleTable.toggleRowSelection(item);
              }
            });
            val.deviceIds && val.deviceIds.split(",").map(function (v) {
              if (item.deviceList.length > 0) {
                item.deviceList.map(function (t) {
                  if (t.id == v) {
                    _this4.toggleSelection(t, true);
                  }
                });
              }
            });
          });
        });

        _this4.loading = false;
        var _res = res,
            total = _res.total,
            pages = _res.pages,
            current = _res.current,
            size = _res.size; // this.param.total =  total;
        // this.param.pages = pages;
        // this.param.current = current;
        // this.param.size =  size ;
      });
    },
    handleCheckChange: function handleCheckChange(val) {
      var checkFlag = !val.checkFlag;

      if (checkFlag) {
        if (!this.isInArray(this.multipleSelection, val.gatewayId)) {
          this.multipleSelection.push(val.gatewayId);
          return;
        }
      } else {
        if (this.isInArray(this.multipleSelection, val.gatewayId)) {
          var index = this.multipleSelection.indexOf(val.gatewayId);
          this.multipleSelection.splice(index, 1);
          return;
        }
      }
    },
    // 分页导航
    handleCurrentChange: function handleCurrentChange(val) {
      this.param.current = val;
      this.getUserStation();
    },
    // 提交表单
    handleSubmit: function handleSubmit() {
      var _this5 = this;

      distribute({
        userId: this.param.userId,
        deviceList: this.multipleSelection
      }).then(function (res) {
        if (res.data.code === 200) {
          _this5.handleClose('0');

          _this5.$message.success(_this5.$t('stationModal.setSuc'));
        } else {
          _this5.$message.error(_this5.$t('stationModal.setFauRepeat'));
        }
      });
    },
    beforeClose: function beforeClose(done) {
      this.multipleSelection.length = 0;
      this.param.userStation = [];
      this.$emit('closeStation');
      done();
    },
    handleClose: function handleClose(num) {
      this.multipleSelection.length = 0;
      this.param.userStation = [];
      this.$emit('closeStation', num);
    },
    isInArray: function isInArray(arr, value) {
      if (arr.indexOf && typeof arr.indexOf == 'function') {
        var index = arr.indexOf(value);

        if (index >= 0) {
          return true;
        }
      }

      return false;
    }
  }
};